var _defs, _g, _g2, _g3, _g4, _path, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiIconLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_30565",
    "data-name": "Group 30565",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 224.731,
    height: 279.441,
    viewBox: "0 0 224.731 279.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.12,
    y1: 0.5,
    x2: 0.933,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0a5b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4e8ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 0.325,
    x2: 0.5,
    y2: 1.185,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0a5b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6babf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 0.292,
    x2: 0.5,
    y2: 1.167,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e8ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a0a5b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    y1: 0.112,
    x2: 0.5,
    y2: 0.987,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1.485,
    y1: 1.229,
    x2: 0.136,
    y2: 0.092,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.534,
    r: 0.871,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#351f60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e0e2b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.5,
    cy: 0.499,
    r: 0.633,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af84d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e6ccb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 0.5,
    cy: 0.663,
    r: 2.136,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30441",
    "data-name": "Group 30441",
    transform: "translate(0 100.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15263",
    "data-name": "Path 15263",
    d: "M140.048,607.084c-1.677,7.4-10.306,6.2-21.906.883C104.29,601.615,84.618,579.4,88.7,561.676v0a20.019,20.019,0,0,1,1.729-4.714c9.446-18.264,47.265,32.566,49.121,40.9C140.431,601.808,140.559,604.841,140.048,607.084Z",
    transform: "translate(-88.156 -553.026)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15264",
    "data-name": "Path 15264",
    d: "M140.048,621.511c-1.677,7.4-10.306,6.2-21.906.883C104.29,616.042,84.618,593.829,88.7,576.1,94.81,591.359,109.23,615.839,140.048,621.511Z",
    transform: "translate(-88.156 -567.453)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15265",
    "data-name": "Path 15265",
    d: "M122.839,568.014c3.279,3.569,8.142,9.979,7,11.2-1.169,1.243-8.636-2.9-13.715-8.957-3.467-4.137-6.458-9.93-5.318-10.916C112.094,558.223,118.563,563.361,122.839,568.014Z",
    transform: "translate(-102.16 -556.875)",
    fill: "#fff",
    opacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30442",
    "data-name": "Group 30442",
    transform: "translate(62.104 145.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15266",
    "data-name": "Path 15266",
    d: "M368.86,701.278c0,30.861-21.651,67.111-56.05,67.111-21.316,0-38.857-13.05-49.111-30.5a70.18,70.18,0,0,1-9.862-35.107c0-31.616,34.507-30.11,56.375-30.11,23.984,0,52.455-1.837,57.764,20.5A34.536,34.536,0,0,1,368.86,701.278Z",
    transform: "translate(-253.837 -672.638)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15267",
    "data-name": "Path 15267",
    d: "M385.308,735.527c0,30.861-21.651,67.111-56.049,67.111-21.316,0-38.857-13.05-49.111-30.5,21.363,10.055,82.216,30.885,104.277-44.719A34.531,34.531,0,0,1,385.308,735.527Z",
    transform: "translate(-270.285 -706.887)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15268",
    "data-name": "Path 15268",
    d: "M282.2,708.822c-4.468,7.286-1.308,17.654,6.365,21.725,8.11,4.3,19.143.445,22.159-8.107,2.865-8.124-2.655-17.23-10.564-19.784C293.815,700.607,285.912,702.764,282.2,708.822Z",
    transform: "translate(-270.286 -690.933)",
    fill: "#fff",
    opacity: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30443",
    "data-name": "Group 30443",
    transform: "translate(183.799 148.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15269",
    "data-name": "Path 15269",
    d: "M619.42,729.93c-.345,14.184-3.651,22.841-13.064,18.335a29.142,29.142,0,0,1-5.408-3.523c-6.678-5.328-35.773-61.6-15.213-62.086a22.488,22.488,0,0,1,14.41,5.167C612.355,697.3,619.723,717.6,619.42,729.93Z",
    transform: "translate(-578.498 -682.651)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15270",
    "data-name": "Path 15270",
    d: "M655.524,738.557c-.345,14.184-3.651,22.841-13.064,18.335,3.046-7.5,5.748-24.8-6.211-60.442C648.459,705.93,655.827,726.229,655.524,738.557Z",
    transform: "translate(-614.602 -691.278)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15271",
    "data-name": "Path 15271",
    d: "M599.963,730.651c3.8,8.814,9.465,24.156,7.837,24.91-1.468.68-9.069-10.413-13.155-23.231-2.276-7.14-3.7-15.56-2.519-15.953C593.594,715.887,598.78,727.909,599.963,730.651Z",
    transform: "translate(-586.752 -703.726)",
    fill: "#fff",
    opacity: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30448",
    "data-name": "Group 30448",
    transform: "translate(39.152 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15272",
    "data-name": "Path 15272",
    d: "M236.239,437.439a22.282,22.282,0,0,1-4.7-6.9,21.395,21.395,0,0,1,14.807-29.638,22.15,22.15,0,0,1,5.5-.609C256.129,424.767,236.239,437.439,236.239,437.439Z",
    transform: "translate(-215.79 -357.286)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15273",
    "data-name": "Path 15273",
    d: "M239.322,437.439a22.279,22.279,0,0,1-4.7-6.9c2.5-4.359,5.007-9,7.481-13.92,2.727-5.422,5.157-10.677,7.326-15.717a22.151,22.151,0,0,1,5.5-.609Z",
    transform: "translate(-218.873 -357.286)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15274",
    "data-name": "Path 15274",
    d: "M366.037,422.352c-2.206,30.578-72.311,40.681-105.1,22.2-9.111-5.134-15.341-12.478-16.437-22.2-5.04-44.709,24.561-85.645,58.567-85.645,12.327,0,26.8,4.718,38.791,15.171C357.219,365.258,368.517,388.043,366.037,422.352Z",
    transform: "translate(-224.694 -317.534)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15275",
    "data-name": "Path 15275",
    d: "M214.8,362.687a31.766,31.766,0,0,1-10.808-10.922c-4.246-6.916-8.178-18.924-2.8-36.86l3.167.95c-4.015,13.382-3.221,24.832,2.357,34.031a29.067,29.067,0,0,0,9.647,9.889Z",
    transform: "translate(-196.343 -303.905)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4038",
    "data-name": "Ellipse 4038",
    cx: 7.697,
    cy: 7.697,
    rx: 7.697,
    ry: 7.697,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15276",
    "data-name": "Path 15276",
    d: "M375.265,453c0,6.135-6.735,9.914-15.417,12.158-9.144,2.366-20.446,3.032-28.315,2.957-11.265-.109-32.991-2.064-40.827-9.2A7.9,7.9,0,0,1,287.8,453a23.684,23.684,0,0,1,7.245-17.022,25.023,25.023,0,0,1,17.5-7.047H350.52a24.949,24.949,0,0,1,19.539,9.3A23.554,23.554,0,0,1,375.265,453Z",
    transform: "translate(-252.115 -375.188)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15278",
    "data-name": "Path 15278",
    d: "M365.525,573.278a26.28,26.28,0,0,1-16.876-5.852c-7.292-5.909-9.612-14.207-7.274-14.392,3.637-.278,12.313,4.062,22.109,4.062,11.255,0,18.926-2.834,24.712-3.07.26-.014.51-.019.76-.019C394.832,554.008,387.639,573.278,365.525,573.278Z",
    transform: "translate(-285.063 -452.766)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15279",
    "data-name": "Path 15279",
    d: "M394.388,447.653c-2.206,30.578-72.311,40.68-105.1,22.2,20.036,3.325,79.679,10.627,90.41-18.108,9.229-24.712-2.182-57.684-9.489-74.564C385.57,390.56,396.867,413.344,394.388,447.653Z",
    transform: "translate(-253.045 -342.836)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15280",
    "data-name": "Path 15280",
    d: "M296.682,375.658c1.812,2.39,12.952-2.612,20.432-8.117,7.17-5.276,14.49-13.6,12.875-15.954-1.434-2.092-9.661.889-14.834,3.639C303.575,361.379,294.708,373.055,296.682,375.658Z",
    transform: "translate(-257.497 -326.398)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15281",
    "data-name": "Path 15281",
    d: "M253.819,525.241c.265,8.169,5.256,15.923,7.276,15.394,2.119-.555,1.257-10.311.28-15.674-.28-1.539-2-10.956-4.2-10.916C255.444,514.078,253.647,519.951,253.819,525.241Z",
    transform: "translate(-230.867 -428.4)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30445",
    "data-name": "Group 30445",
    transform: "translate(91.383 59.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30444",
    "data-name": "Group 30444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15282",
    "data-name": "Path 15282",
    d: "M463.55,460.9a11.065,11.065,0,1,1-.971-4.522A11.054,11.054,0,0,1,463.55,460.9Z",
    transform: "translate(-439.548 -447.96)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15283",
    "data-name": "Path 15283",
    d: "M449.343,446.7a11.059,11.059,0,1,1-11.057,11.054A11.046,11.046,0,0,1,449.343,446.7Zm0-1.889a12.944,12.944,0,1,0,12.944,12.944,12.784,12.784,0,0,0-1.138-5.3,12.95,12.95,0,0,0-11.805-7.643Z",
    transform: "translate(-436.397 -444.809)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4039",
    "data-name": "Ellipse 4039",
    cx: 3.67,
    cy: 3.67,
    rx: 3.67,
    ry: 3.67,
    transform: "translate(5.124 5.604)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15285",
    "data-name": "Path 15285",
    d: "M479.584,485.01c.6.4-.217,4.254-2.953,5.727-2.431,1.309-5.652.351-5.728-.358-.055-.521,1.614-.663,4.407-2.354C478.249,486.246,479.166,484.729,479.584,485.01Z",
    transform: "translate(-457.968 -469.92)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30447",
    "data-name": "Group 30447",
    transform: "translate(42.342 59.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30446",
    "data-name": "Group 30446"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15286",
    "data-name": "Path 15286",
    d: "M332.717,460.9a11.065,11.065,0,1,1-.971-4.522A10.942,10.942,0,0,1,332.717,460.9Z",
    transform: "translate(-308.716 -447.958)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15287",
    "data-name": "Path 15287",
    d: "M318.511,446.7a11.059,11.059,0,1,1-11.057,11.054A11.045,11.045,0,0,1,318.511,446.7Zm0-1.889a12.944,12.944,0,1,0,12.944,12.943,12.785,12.785,0,0,0-1.138-5.3,12.951,12.951,0,0,0-11.806-7.643Z",
    transform: "translate(-305.566 -444.807)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4040",
    "data-name": "Ellipse 4040",
    cx: 3.67,
    cy: 3.67,
    rx: 3.67,
    ry: 3.67,
    transform: "translate(5.124 5.604)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15289",
    "data-name": "Path 15289",
    d: "M348.751,485.008c.6.4-.217,4.254-2.953,5.727-2.431,1.309-5.652.351-5.727-.358-.055-.521,1.614-.663,4.407-2.354C347.417,486.244,348.333,484.727,348.751,485.008Z",
    transform: "translate(-327.136 -469.918)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4041",
    "data-name": "Ellipse 4041",
    cx: 4.13,
    cy: 4.13,
    rx: 4.13,
    ry: 4.13,
    transform: "translate(1.404 2.989) rotate(-18.089)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15291",
    "data-name": "Path 15291",
    d: "M379.116,574.923a26.281,26.281,0,0,1-16.876-5.852c9.786-1.289,29.019-4.808,39.547-13.4.26-.014.51-.019.76-.019C408.423,555.653,401.23,574.923,379.116,574.923Z",
    transform: "translate(-298.654 -454.411)",
    fill: "url(#radial-gradient-3)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15302",
    "data-name": "Path 15302",
    d: "M648.887,318.862l-7.572-1.568v0Z",
    transform: "translate(-433.969 -305.395)",
    fill: "#bbe1f4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4043",
    "data-name": "Ellipse 4043",
    cx: 59.757,
    cy: 15.493,
    rx: 59.757,
    ry: 15.493,
    transform: "translate(60.04 248.455)",
    opacity: 0.2,
    fill: "url(#radial-gradient-8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIconLg);
export default __webpack_public_path__ + "static/media/ai_icon_lg.decea0dbdb0437efcb1a8c6139c700de.svg";
export { ForwardRef as ReactComponent };